<template>
  <span class="likes-and-comments-relative">
    <span class="likes-and-comments-anchor" id="likes-and-comments"></span>
  </span>
  <div v-if="renderComponent" class="d-flex justify-content-between align-items-center like-and-comments" >

    <likes :likedContentUuid="articleUuid" category="article" />
    <comments-counter
      :article-uuid="articleUuid"
      use-bold-font
      :article-url="articleUrl"
      :showSmall=false  />
   </div>
   <div class="comments border-top pt-3 mt-3">
     <comments-list
        :threadId="articleUuid"
        :forceShowDeleteCommentButtons="forceShowDeleteCommentButtons"
        @commentsChanged="forceRerender"
     />
   </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import Likes from './components/likes/Likes.vue'
import CommentsCounter from './components/comments/CommentsCounter.vue'
import CommentsList from './components/comments/CommentsList.vue'

export default defineComponent({
  components: {
    Likes,
    CommentsCounter,
    CommentsList
  },
  name: 'WidgetLikesAndComments',
  props: {
    articleUuid: String,
    vueWidgetLikesAndComments: String,
    forceShowDeleteCommentButtons: Boolean,
    articleUrl: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      renderComponent: true,
    };
  },
  methods: {
    forceRerender() {
      this.renderComponent = false
      this.$nextTick(() => {
          // Add the component back in
        this.renderComponent = true;
       });
    }
  }

});
</script>

